export default __webpack_public_path__ + "112acb4de1898d278c48732332509b28.jpg";